<script lang="ts">
  import { Col } from "sveltestrap"

  export let currency: string;
</script>

<Col class="col-auto">
  <div class="token-input-label">
    {#if currency === 'PIL'}
      <img class="icon-small" src="/icons/pil-fill.svg" alt="placeholder"/>
      &nbsp;&nbsp;PIL
    {:else if currency === 'xPIL'}
      <img class="icon-small" src="/icons/pil-fill.svg" alt="placeholder"/>
      &nbsp;&nbsp;xPIL
    {:else if currency === 'USDC'}
      <img class="icon-small" src="/icons/currency-usdc.svg" alt="placeholder"/>
      &nbsp;&nbsp;USDC
    {:else if currency === 'WETH'}
      <img class="icon-small" src="/icons/currency-eth.svg" alt="placeholder"/>
      &nbsp;&nbsp;WETH
    {:else if currency === 'ROUND'}
      <img class="icon-small" src="/icons/round.svg" alt="placeholder"/>
      &nbsp;&nbsp;Round
    {:else}
      {currency}
    {/if}
  </div>
</Col>
